<template>
    <b-dropdown :text=selectedUserName>
        <b-dropdown-item v-for="user in activeUsers" :key="user.id" v-on:click="userSelected(user)">{{user.firstName}} {{user.lastName}}</b-dropdown-item>
    </b-dropdown>
</template>

<script>
import { globalStore } from "../../shared/helpers";
import { userService } from "../../shared/services";

export default {
    computed: {
        activeUsers() {
            return this.users.filter(u => u.isActive);
        },
        selectedUserName() {
            return this.selectedUser ? `${this.selectedUser.firstName} ${this.selectedUser.lastName}` : "Välj användare";
        }
    },
    methods: {
        userSelected(user) {
            this.selectedUser = user;
            this.$emit("onUserSelected", user);
        },
    },
    props: {
        selectedUserId: Number,
        employeeOnly: false
    },
    data () {
        return {
            loading: true,
            users: [],
            selectedUser: null
        }
    },
    mounted() {
        userService.get().then(p => {
            this.users = this.employeeOnly ? p.filter(p => p.isEmployee) : p;
            if(this.selectedUserId)
            {
                var selectedUser = this.users.filter(u => u.id == this.selectedUserId)[0];
                if(selectedUser) this.selectedUser = selectedUser;
            }

        }).catch(() => {
            this.ShowToast("Fel", "Ett okänt fel uppstod när användare skulle hämtas", "danger")
            })
    },
      
}
</script>

<style>

</style>
